import { render, staticRenderFns } from "./NoCampaigns.vue?vue&type=template&id=37a61c62&scoped=true&"
var script = {}
import style0 from "./NoCampaigns.vue?vue&type=style&index=0&id=37a61c62&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a61c62",
  null
  
)

export default component.exports